var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGrading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 42,
    viewBox: "0 0 36 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 9.75H33.75C34.9875 9.75 36 10.7625 36 12C36 13.2375 34.9875 14.25 33.75 14.25H2.25C1.0125 14.25 0 13.2375 0 12C0 10.7625 1.0125 9.75 2.25 9.75Z",
    fill: "#FCBE40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 23.25H33.75C34.9875 23.25 36 22.2375 36 21C36 19.7625 34.9875 18.75 33.75 18.75H2.25C1.0125 18.75 0 19.7625 0 21C0 22.2375 1.0125 23.25 2.25 23.25Z",
    fill: "#FCBE40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 32.25H13.5C14.7375 32.25 15.75 31.2375 15.75 30C15.75 28.7625 14.7375 27.75 13.5 27.75H2.25C1.0125 27.75 0 28.7625 0 30C0 31.2375 1.0125 32.25 2.25 32.25Z",
    fill: "#FCBE40"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 41.25H13.5C14.7375 41.25 15.75 40.2375 15.75 39C15.75 37.7625 14.7375 36.75 13.5 36.75H2.25C1.0125 36.75 0 37.7625 0 39C0 40.2375 1.0125 41.25 2.25 41.25Z",
    fill: "#FCBE40"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6723 34.8826L24.0748 33.2851C23.1973 32.4076 21.7798 32.4076 20.9023 33.2851C20.0248 34.1626 20.0248 35.5801 20.9023 36.4576L24.0973 39.6526C24.9748 40.5301 26.3923 40.5301 27.2698 39.6526L34.4023 32.5201C35.2798 31.6426 35.2798 30.2251 34.4023 29.3476C33.5248 28.4701 32.1073 28.4701 31.2298 29.3476L25.6723 34.8826Z",
    fill: "#FCBE40"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 4.2375 1.0125 5.25 2.25 5.25H33.75C34.9875 5.25 36 4.2375 36 3C36 1.7625 34.9875 0.75 33.75 0.75H2.25C1.0125 0.75 0 1.7625 0 3Z",
    fill: "#FCBE40"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGrading);
export default __webpack_public_path__ + "static/media/icon-grading.101ffc66.svg";
export { ForwardRef as ReactComponent };